import React, { useState, useRef, useEffect } from "react";
import { Formik } from "formik";
import { Button, FormGroup, Label, Row, Col, Input } from "reactstrap";
import * as Yup from "yup";
import { cloneDeep } from "lodash";
import CoveredEntity from "components/CoveredEntity";
import NPIProviderList from "components/NPIProviderList";
import { ModuleAccess } from "utils/moduleaccess";
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";

// const validationSchema = Yup.object({
//   coveredEntityName: Yup.string().required("Please select covered entity"),
// });

const providerStatusOpt = [
  { id: "", label: "Provider Research Required" },
  { id: "Y", label: "Eligible" },
  { id: "N", label: "Ineligible" },
];
let ceerror = ''

const SearchContainer = (props) => {
  const {
    filterBySearch,
    onSearch,
    onReset,
    providerFilters,
    handleUpdateEntity,
    onManualSearch,
    selectedCEId,
    orgId,
  } = props;
  const formikRef = useRef();

  const [selectedCoveredEntity, setSelectedCoveredEntity] = useState({});
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedEligibleFlag, setSelectEdeligibleFlag] = useState(
    selectedCEId !== "" ? "" : "-1"
  );
  const [selectedCE, setSelectedCE] = useState(selectedCEId);
  const [hasPPC, setHasPPC] = useState(false);
  useEffect(() => {
    if (providerFilters) {
      setPreValue();
    }

    if (selectedCEId) {
      setSelectEdeligibleFlag("");
    }
    setHasPPC(ModuleAccess("PRD", "PPC"));
  }, []);
  // const handleCombo = async () => {
  //   await onManualSearch();
  // }

  const onHandleManualProgram = () => {
    setOpenProgram(!isOpenProgram);
  };

  const setPreValue = () => {
    if (formikRef.current) {
      const { setFieldValue } = formikRef.current;

      const { coveredEntityName } = providerFilters;
      setFieldValue(
        "coveredEntityName",
        coveredEntityName ? parseInt(coveredEntityName) : ""
      );
    }
  };

  const handleSubmit = async (val) => {
    //const { setSubmitting } = actions;
    var values = cloneDeep(val);
    values.providerID = selectedProvider;
    values.eligibleFlag = selectedEligibleFlag;
    if (selectedCEId == "" && window.selectedCoveredEntittyId == "") {
      ceerror = "Please Select Covered Entity "
    }
    await onSearch(values);
    //setSubmitting(false);
  };

  const handleCoverdEntityChange = async (value, setFieldValue, entity) => {
    window.selectedCoveredEntittyId = value;
    ceerror = ""
    setSelectedCE(value);
    handleUpdateEntity(entity);
    setFieldValue("coveredEntityName", value);
    setSelectedCoveredEntity(entity);
    setSelectedProvider(null);
    if (selectedCEId) {
      let param = {};

      param.coveredEntityName = value;
      await handleSubmit(param);
    }


  };


  const onSelect = (provider) => {
    setSelectedProvider(provider);
  };

  useEffect(() => {
    setSelectedProvider(null);
    ceerror = ""
  }, [orgId])


  const handleReset = ({ resetForm }) => {
    resetForm();
    onReset();
    setSelectedCE("");
    setSelectedProvider(null);
    ceerror = ""
    setSelectEdeligibleFlag("-1");
    window.selectedCoveredEntittyId = "";
  };


  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={filterBySearch}
        onSubmit={handleSubmit}
        // validationSchema={validationSchema}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue } =
            props;
          return (
            <div>
              <h5 className="f-16 text-primary font-weight-700">
                Search Providers
              </h5>
              <Row sm={5}>
                <Col md={3} sm={3} xs={3}>
                  {" "}
                  <FormGroup>
                    <Label for="coveredEntityID">Covered Entity</Label>
                    <CoveredEntity
                      value={selectedCE}
                      name="coveredEntityName"
                      orgId={orgId}
                      onChange={(value, enty) =>
                        handleCoverdEntityChange(value, setFieldValue, enty)
                      }
                    />
                    {(ceerror.length > 0) ? (<div className="text-danger f-12">
                      {ceerror}
                    </div>) : null}
                  </FormGroup>
                </Col>
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label>NPI/Provider Name</Label>
                    <NPIProviderList
                      tenantID={selectedCoveredEntity.tenantID}
                      onSelect={onSelect}
                      selectedProvider={selectedProvider}
                    />
                  </FormGroup>
                </Col>

                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label>Provider Status</Label>
                    <Input
                      id="eligibleFlag"
                      name="eligibleFlag"
                      type="select"
                      value={selectedEligibleFlag}
                      onChange={(e) => {
                        setSelectEdeligibleFlag(e.target.value);
                      }}
                    >
                      <option value={"-1"}>--Select--</option>
                      {providerStatusOpt.map((status) => {
                        const { id, label } = status;
                        return (
                          <option key={id} value={id}>
                            {label}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row sm={5} className="justify-content-end">
                <Col md="auto" className="">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="search"
                  >
                    <span className="right_5">
                      <img src={search} alt="" />
                    </span>{" "}
                    Search
                  </Button>
                  <Button
                    className="reset ms-2"
                    color="primary"
                    onClick={() => handleReset(props)}
                  >
                    <span className="right_5">
                      <img src={reseticon} alt="" />
                    </span>{" "}
                    Reset
                  </Button>
                  {/* <Button disabled={!selectedCE}
                    onClick={handleCombo}
                    color="primary"
                    className="ms-3"
                    hidden={!hasPPC}
                  >
                    Auto-Approve Prov. & Pt. Combo

                  </Button> */}
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </>
  );
};

export default SearchContainer;
